'use client';
import { Button } from '@/components/ui/button';
import { NEW_USER_RIGHTS } from '@/config/site';
import { useAuth } from '@/providers/auth-provider';
import { PlusIcon, UserPlusIcon } from 'lucide-react';

const AdBanner = () => {
  const { loading, user, triggerLogin } = useAuth();
  return !loading && !user ? (
    <div className="flex items-center px-6 rounded-full">
      <div className="container mx-auto relative">
        <div className="flex items-center justify-center gap-3 text-center">
          <div className="flex items-center gap-2">
            <div className="bg-background text-xs rounded-full px-2 py-1">
              新用户专享
            </div>
            <div className="font-medium flex items-center gap-x-1">
              <span>免费体验 7 天高级版会员</span>
              <PlusIcon className="w-4 h-4" />
              <span>赠送 {NEW_USER_RIGHTS.points.toLocaleString()} 积分</span>
            </div>
          </div>
          <Button
            size="sm"
            className="h-7"
            onClick={() => {
              triggerLogin && triggerLogin();
            }}
          >
            <UserPlusIcon className="w-3 h-3" />
            注册即享
          </Button>
        </div>
      </div>
    </div>
  ) : null;
};

export default AdBanner;
